import { createContext, useContext } from 'react';
import type { UserTableViewsContextValue } from './userTableSettings.model';

export const UserTableViewsContext = createContext<UserTableViewsContextValue | undefined>(undefined);

export const useUserTableViews = (): UserTableViewsContextValue => {
  const context = useContext(UserTableViewsContext);
  if (!context) {
    throw new Error('useUserTableViews must be used within UserTableViewsProvider');
  }
  return context;
};
